// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort[data-v-53ece026]{display:flex;flex-wrap:wrap;margin-bottom:-2px}.sort__title[data-v-53ece026]{display:flex;margin-right:16px;line-height:19px}.sort__el[data-v-53ece026]{margin-right:14px;line-height:19px;cursor:pointer}.sort__el[data-v-53ece026]:hover,.sort__el_active[data-v-53ece026]{color:#eb0010}@media (max-width:800px){.sort__title[data-v-53ece026]{width:100%;font-weight:500}.sort__el[data-v-53ece026]{margin-right:9px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
